import React from "react";
import style from "./Card.module.css";
import { FaSkype as Skype, FaLinkedinIn as LinkedIn } from "react-icons/fa";

export default function Card({ name, designation, imgSrc, skype, linkedIn }) {
  return (
    <div className={style.singleCard}>
      <div className={style.imageDiv}>
        <img alt="person" src={imgSrc} className={style.cardFig}></img>
      </div>
      <div className={style.descriptionDiv}>
        <span className={style.name}>{name}</span>
        <span className={style.designation}>{designation}</span>
        <div className={style.socialAccounts}>
          <div className={style.skype}>
            <a href={skype} className={style.cardLink}>
              <Skype className={style.skypeIcon} />
            </a>
          </div>
          <div className={style.linkedIn}>
            <a href={linkedIn} className={style.cardLink}>
              <LinkedIn className={style.linkedInIcon} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}
